import {useState} from 'react'
import {useDispatch} from 'react-redux'
import {Formik} from 'formik'
import CustomSelect from '../../components/core/customSelect'
import {SimpleBlueButton} from '../../components/core/button'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import {updateTeamMember} from '../../stores/members'
import rolesData from '../../data/roles.json'
import Customer from '../../utils/customer'
import localStorageKeys from '../../utils/localStorageKeys'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const UpdateModal = ({teamId, member, closeModal, teams = []}) => {
    const text = useNamespaceTranslations('members')
    const [buttonIsDisabled, setButtonIsDisabled] = useState(true)
    const [loader, setLoader] = useState(false)
    const [active, setActive] = useState(null)

    const roles = Object.values(rolesData).filter(item => item.show)
    const isCurrentUser = Customer.isCurrentUser(member?.customer_id)

    const names = {
        new_team_id: 'new_team_id',
        role: 'role'
    }

    const initialFormValues = {
        [names.new_team_id]: teams?.find(item => item?.value === teamId),
        [names.role]: rolesData[member?.role]
    }

    const dispatch = useDispatch()

    const updateMember = async(values, {setFieldError}) => {
        setLoader(true)
        const success = await dispatch(updateTeamMember(teamId, member?.customer_id, {
            [names.new_team_id]: values[names.new_team_id]?.value,
            [names.role]: values[names.role]?.value
        }, setFieldError))
        if (success) {
            localStorage.setItem(localStorageKeys.TEAM_ID, values[names.new_team_id].value)
            closeModal()
        }
        setLoader(false)
    }

    const handleInfo = (index, state) => {
        state ? setActive(index) : setActive(null)
    }

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialFormValues}
            onSubmit={updateMember}
            validateOnBlur={false}
            validateOnChange={false}
        >
            {({values, setFieldValue, errors, handleSubmit}) => (
                <form onSubmit={handleSubmit} className="modal-body">
                    <CustomSelect
                        options={teams}
                        name={names.new_team_id}
                        placeholder={text.team}
                        onChange={(name, data) => {
                            setFieldValue(name, data)
                            setButtonIsDisabled(false)
                        }}
                        error={errors.new_team_id}
                        value={values.new_team_id}
                        activeInfo={active === names.new_team_id}
                        infoText={text.team_info}
                        handleInfo={(state) => handleInfo(names.new_team_id, state)}
                    />
                    {!isCurrentUser && (
                        <CustomSelect
                            options={roles}
                            name={names.role}
                            placeholder={text.role}
                            onChange={(name, data) => {
                                setFieldValue(name, data)
                                setButtonIsDisabled(false)
                            }}
                            error={errors.role}
                            value={values.role}
                            activeInfo={active === names.role}
                            infoText={text.role_info}
                            handleInfo={(state) => handleInfo(names.role, state)}
                        />
                    )}
                    <SimpleBlueButton
                        disabled={buttonIsDisabled || loader}
                        type="submit"
                    >
                        {loader && <ButtonLoader/>}
                        <span>{text.submit}</span>
                    </SimpleBlueButton>
                </form>
            )}
        </Formik>
    )
}

export default UpdateModal
